import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const ModalPanelContext = /*#__PURE__*/createContext(undefined);
export const ModalPanelProvider = ({
  overlayStylesOverrides,
  formStylesOverrides,
  children
}) => {
  return /*#__PURE__*/_jsx(ModalPanelContext.Provider, {
    value: {
      overlayStylesOverrides,
      formStylesOverrides
    },
    children: children
  });
};

/**
 * Provides the context for the `ModalPanel` component.
 * Note: The context is only available when the `ModalPanel` component is rendered as an ancestor.
 * @returns ModalPanelContext - The context for the `ModalPanel` component.
 * @returns ModalPanelContext.overlayStylesOverrides - Style overrides to be applied to the `Overlay` component.
 * @returns ModalPanelContext.formStylesOverrides - Style overrides to be applied to the `Form` component.
 */
export const useModalPanelContext = () => {
  const modalPanelContext = useContext(ModalPanelContext);
  return modalPanelContext;
};